import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const QualityInternationalStepConfig: StepConfig = {
    type: FormType.QUALITY_INTERNATIONAL
};
